<template>
  <div style="width: 100%;">
    <v-container>
      <v-row>
        <v-col class="d-flex flex-row align-center">
          <v-btn text class="mx-2" @click="()=>{this.$router.go(-1)}">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <h1>{{this.plural}}</h1>
          <v-btn
            v-if="this.isAllowed('user', 'testPerm')"
            class="mx-2"
            fab
            small
            dark
            color="info"
            @click="create"
          >
            <v-icon dark>
              mdi-plus
            </v-icon>
          </v-btn>
          <v-btn class="mx-2" dark color="info" to="/usertypes">User Types</v-btn>
          <v-progress-circular
            indeterminate
            color="green"
            v-if="loader"
            style="margin-left: 10px;"
          ></v-progress-circular>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
            <v-data-table
              :headers="headers"
              :items="data"
              :items-per-page="1000000"
              class="elevation-1"
              @click:row="rowClick"
            >
            </v-data-table>
        </v-col>
      </v-row>
    </v-container>
    <dialog-snack ref="snackbar" :color="snackObj.color" :text="snackObj.text"/>
  </div>
</template>
<script>
  import axios from 'axios';
  import { mapGetters } from "vuex"
  import moment from "moment";
  export default {
    data () {
      return {
        deleteDialog: false,
        deleteConfirmed: true,
        loader: true,
        snackObj: {
          color: '',
          text: ''
        },
        max25chars: v => v.length <= 25 || 'Input too long!',
        headers: [
          { text: "ID", align: "start", sortable: true, value: "id"},
          { text: 'First Name', sortable: true, value: 'firstName' },
          { text: 'Last Name', sortable: true, value: 'lastName' },
          { text: 'Address', value: 'address' },
          { text: 'Date of Birth', sortable: true, value: 'dob' },
          { text: 'Phone', value: 'phone' },
          { text: 'Email', sortable: true, value: 'email' },
          { text: 'Username', sortable: true, value: 'username' },
          { text: 'User Type', value: 'UserType.name' },
          { text: 'Online', value: 'isLoggedIn' }
        ],
        editMode: false,
        data: [],
        singular: "User",
        singularLower: "user",
        plural: "Users",
        pluralLower: "users"
      }
    },
    async mounted(){
        try {
          if(!this.isAllowed('user','manage')){
            console.log("not allowed")
            await this.$router.push({path: '/'})
          }else {
            let res = await axios.get(`${this.getEndpoint}/api/${this.pluralLower}`)
            this.data = res.data
            this.data.forEach(user => {
              if(user.dateOfBirth){
                user.dateOfBirth = new Date(user.dateOfBirth).toISOString().substring(0, 10);

                user.dob = this.momentDateFormat(user.dateOfBirth);
              }
            });
          }
        } catch (error) {
          console.error(error);
          this.snack(error.msg || error, "error");
        } finally {
            this.loader = false;
        }
    },
    computed: {
      ...mapGetters(['getUser', 'getId', 'getToken', 'isAllowed', 'getEndpoint'])
    },
    methods: {
      snack(text, color=""){
        this.snackObj.text = text;
        this.snackObj.color = color;

        this.$refs.snackbar.openDialog();
      },
      rowClick(row){
        this.$router.push({ path: `/${this.pluralLower}/view/${row.id}`})
      },
      create(){
        this.$router.push({ path: `/${this.pluralLower}/create`})
      },
      momentDateFormat (date) {
        return date ? moment(this.parseISODate(date)).format('ddd, MMM Do YYYY') : '';
      },
      parseISODate(date){
        return (date?new Date(date).toISOString().substring(0, 10):null);
      },
    }
  }
</script>
